<div 
  class="question-card" 
  [class.disabled]="disabled"
  (click)="onCardClick()">
  <p class="question-text" [innerHTML]="question"></p>
  <!-- <div class="question-icon">
    <img src="assets/icons/question-mark-icon.svg" alt="Question mark" class="question-icon-img">
  </div> -->
  
</div>
